/**
 * operations utilities
 * 
 * @author    Jens Gruschel
 * @copyright © 2018 contexagon GmbH
 */



export function getCardImageUrl(object, typeDefinitions) {

    // the URL given by the server has precedence
    if (object.thumbnailurl) {
        return object.thumbnailurl;
    }
    else if (object.imageurl) {
        return object.imageurl;
    }

    // media items define their own URL
    if (object.type === "mediaitem" && object.fields && object.fields.url) {
        return object.fields.url;
    }

    // maybe there is a placeholder defined for this type
    const typeDefinition = typeDefinitions[object.type];
    if (typeDefinition && typeDefinition.fields && typeDefinition.fields.placeholderurl) {
        return typeDefinition.fields.placeholderurl;
    }

    // nothing else worked
    return "placeholders/file.svg";
}

export function getMediaUrl(object) {

    if (Array.isArray(object)) {
        return getMediaUrl(object[0]);
    }

    // for media items the URL defined explicitely has precedence
    if (object && object.type === "mediaitem") {
        return (object.mediainfo && object.mediainfo.webformat) || (object.fields && object.fields.url);
    }

    // otherwise there is no media URL
    return undefined;
}
